<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div
      class="nav gap-x-3"
      title="HuiWuDetailRenYuanList"
      data-title="签到管理"
    >
      <el-input
        v-model="state.params.keywords"
        class="c-search-white"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg p-2.5">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        row-key="id"
        ref="tableDom"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column :width="120" align="center">
          <template #header>
            <div
              class="c-table-col-header text-center w-full"
              label1="状态"
              label2="起始时间"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value2="row.date">
              <template #top>
                <div class="flex flex-col items-center">
                  <c_status
                    arrName="Meeting_Schedule_Status"
                    :value="row.status"
                    showBg
                  />
                  <strong
                    >{{ $dayjs(row.start_time, "HH:mm:ss").format("HH:mm") }} ~
                    {{
                      $dayjs(row.end_time, "HH:mm:ss").format("HH:mm")
                    }}</strong
                  >
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column :width="400">
          <template #header>
            <div
              class="c-table-col-header"
              label1="日程信息"
              label2="所属会场/地址"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value2="row.meetingPlace?.hotel?.address">
              <template #top>
                <div class="flex gap-x-1 items-center">
                  <strong
                    class="gap-x-2 text-green-700 cursor-pointer hover:underline"
                    @click="
                      state.selectItem = row;
                      state.showRecord = true;
                    "
                    >{{ row.name }}</strong
                  >
                  <el-tag
                    type="warning"
                    effect="dark"
                    size="small"
                    v-if="row.is_all_personnel"
                    >全
                  </el-tag>
                  <c_status
                    arrName="Meeting_Schedule_Type"
                    :value="row.type"
                    showBg
                  />
                </div>
                <text class="text-xs">{{ row.meetingPlace?.name }}</text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="参会嘉宾" align="center">
          <template #default="{ row }">
            <strong>{{
              row.meetingAttendeeStatistic?.guest?.count || 0
            }}</strong>
          </template>
        </el-table-column>
        <el-table-column
          label="已签到"
          prop="meetingAttendeeStatistic.signin.guest.signin_count"
          align="center"
        />
        <el-table-column
          label="未签到"
          prop="meetingAttendeeStatistic.signin.guest.unsignin_count"
          align="center"
        />
        <el-table-column
          label="到会率"
          prop="meetingAttendeeStatistic.signin.guest.signin_rate"
          align="center"
        />
        <el-table-column label="参会人" align="center">
          <template #default="{ row }">
            <strong>{{
              row.meetingAttendeeStatistic?.attendee?.count || 0
            }}</strong>
          </template>
        </el-table-column>
        <el-table-column
          label="已签到"
          prop="meetingAttendeeStatistic.signin.attendee.signin_count"
          align="center"
        />
        <el-table-column
          label="未签到"
          prop="meetingAttendeeStatistic.signin.attendee.unsignin_count"
          align="center"
        />
        <el-table-column
          label="到会率"
          prop="meetingAttendeeStatistic.signin.attendee.signin_rate"
          align="center"
        />
        <el-table-column label="操作" fixed="right" align="center" :width="120">
          <template #default="{ row }">
            <el-button
              type="primary"
              :icon="Search"
              link
              @click.stop="
                state.selectItem = row;
                state.showRecord = true;
              "
            >
              签到记录
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
    <el-dialog
      v-model="state.showRecord"
      :title="`${state.selectItem?.name || ''}-签到记录`"
      class="c-el-dialog"
      style="max-height: 95%; min-height: 80%"
      width="400"
      append-to="#huiwu_detail"
      :before-close="
        () => {
          state.showRecord = false;
        }
      "
    >
      <c_record
        :meeting_schedule_id="state.selectItem?.id"
        @close="
          state.showRecord = false;
          onLoad();
        "
      />
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { meeting_service_signin_page } from "@/http/meetingservice";

import c_record from "./Record.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
  },
  components: {
    c_record,
  },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.meeting_id = props.meeting_id;
      // state.params.attend_type = 1; //仅加载嘉宾
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      meeting_service_signin_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    return {
      state,
      props,
      tableDom,
      onLoad,
    };
  },
};
</script>

<style lang="scss" scoped></style>
